import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the DepoKayitlariPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-depo-kayitlari',
  templateUrl: 'depo-kayitlari.html',
})
export class DepoKayitlariPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DepoKayitlariPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/UreticiIslemleri/depo-kayitlari/depo-kayitlari.ts